import { appActions } from '@app';
import dayjs from 'dayjs';
import dayjsduration from 'dayjs/plugin/duration';
import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { getVersion } from '@sonar-software/sonar-core';
import { jwtDecode } from 'jwt-decode';
import { useLocation } from 'react-router-dom';
import { getJWTToken, setIdleSessionTimeout } from '@sonar-software/sonar-ts-lib';
import { useEffect } from 'react';
import { useAction, useAuthToken, useInterval } from '@hooks';
dayjs.extend(dayjsduration);
function checkTokenExpiration(validUntil) {
    const tokenMoment = dayjs(validUntil);
    const nowMoment = dayjs();
    const diff = dayjs.duration(tokenMoment.diff(nowMoment)).minutes();
    if (diff <= 5) {
        getVersion();
    }
}
export const SessionActivityWatcher = () => {
    const location = useLocation();
    const { isLoggedIn } = useAuthToken();
    const hardResetApp = useAction(appActions.hardResetApplication);
    useInterval(() => {
        var _a;
        if (!isLoggedIn) {
            return;
        }
        const decodedToken = jwtDecode((_a = getJWTToken()) !== null && _a !== void 0 ? _a : '');
        const validUntil = decodedToken.exp ? new Date(decodedToken.exp * 1000) : undefined;
        if (validUntil) {
            checkTokenExpiration(validUntil);
        }
    }, 30000);
    useEffect(() => {
        if (isLoggedIn) {
            setIdleSessionTimeout(() => {
                hardResetApp();
                window.location.replace(FULL_ROUTES.LOGIN);
            });
        }
    }, [location.pathname, hardResetApp, isLoggedIn]);
    return null;
};
